import { useLayoutEffect, useState, useRef } from 'react';

export default function getPageScrollPercentage() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [scrollPercent, setScrollPercent] = useState(0);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const rafRef = useRef(null);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const ticking = useRef(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useLayoutEffect(() => {
        function getScrollPercent() {
            if (!ticking.current) {
                // Batch layout reads with requestAnimationFrame to prevent forced reflow
                rafRef.current = requestAnimationFrame(() => {
                    const scrollTop = window.scrollY;
                    const documentHeight = document.body.offsetHeight;
                    const windowHeight = window.innerHeight;
                    const scrollPercentValue = scrollTop / (documentHeight - windowHeight);
                    const scrollPercentRounded = Math.round(scrollPercentValue * 100);
                    setScrollPercent(scrollPercentRounded);
                    ticking.current = false;
                });
                ticking.current = true;
            }
        }
        window.addEventListener('scroll', getScrollPercent );
        getScrollPercent();
        return () => {
            window.removeEventListener('scroll', getScrollPercent);
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }
        };
    }, []);
    return scrollPercent;
}
